import { useMemo } from 'react';
import {
    createBestellpositionViewSchemaNewBestellung,
    createDateSchema,
    createTimeSchema,
} from '../../shared/validation/bestellung/validation';
import { minDate } from '../../shared/helper/date-helper';
import { useSelector } from 'react-redux';
import { selectIsWarenempfaenger } from '../../store/Navigation.store';
import { object } from 'yup';
import { datumWEBisSchema, uhrzeitWEBisSchema } from '../../shared/validation/bestellung/schemas';
import { WUNSCHTERMIN_VALIDATION_ERRORS } from '../../shared/constants';
import { testDebitorWunschterminInFuture } from '../../shared/validation/bestellung/testFunctions';

// NOTE: Ignore because we could not get yup typings working correctly
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useArtikelNutztierFormularSchema = () => {
    const isWarenEmpfaenger = useSelector(selectIsWarenempfaenger);

    return useMemo(() => {
        const DebitorSchema = object({
            bestellpositionenView: createBestellpositionViewSchemaNewBestellung(true),
            datumDebitor: createDateSchema(minDate),
            uhrzeitDebitor: createTimeSchema().test(
                'debitor-wunschtermin-in-future',
                WUNSCHTERMIN_VALIDATION_ERRORS.TIME_IN_THE_PAST,
                testDebitorWunschterminInFuture
            ),
        });

        const WarenempfaengerSchema = object({
            bestellpositionenView: createBestellpositionViewSchemaNewBestellung(false),
            datumWEVon: createDateSchema(minDate),
            datumWEBis: datumWEBisSchema,
            uhrzeitWEVon: createTimeSchema(false),
            uhrzeitWEBis: uhrzeitWEBisSchema,
        });

        return isWarenEmpfaenger ? WarenempfaengerSchema : DebitorSchema;
    }, [isWarenEmpfaenger]);
};
